(() => {
  const sticky = document.querySelector('[data-eo-dylan-sticky]');
  if (!sticky) return;
  let target;
  let observer;
  let queued = false;
  const update = () => {
    queued = false;
    const show = target && target.isConnected && target.getBoundingClientRect().bottom < 0;
    if (!show && sticky.contains(document.activeElement)) return;
    sticky.hidden = !show;
  };
  const bind = () => {
    const next = document.querySelector('[data-eo-commercial-advisor] [data-eo-dylan-call]');
    if (next === target) return update();
    if (observer) observer.disconnect();
    target = next;
    if (target && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(update, { threshold: [0, 1] });
      observer.observe(target);
    }
    update();
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  bind();
  if (!('IntersectionObserver' in window)) window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  sticky.addEventListener('focusout', () => requestAnimationFrame(update));
  document.addEventListener('shopify:section:load', bind);
  const collection = document.getElementById('CollectionAjaxContent');
  if (collection) new MutationObserver(bind).observe(collection, { childList: true, subtree: true });
})();
